import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LdapUser} from '@Services/ldap/ldap/ldap-user.model';
import {DialogData, DialogValidationComponent} from '@Common/widgets/general/dialog-validation';
import {concatMap, filter, finalize, switchMap} from 'rxjs/operators';
import {SnackBarToastyService, typeToast} from '@Common/widgets/general/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {DarDossiersService} from '../../../common/services/dossiers/dossiers.service';
import {Dossiers} from '../../../common/services';
import {RoleHelper, rolesDar} from '../../../common/services/roles';
import {Observable} from 'rxjs';
import {IndividuService} from '@Common/core/services';

/**
 * Le changement de demandeur ne peut se faire que par le Gestionnaire ou Admin
 */
@Component({
  selector: 'app-demandeur-dar',
  templateUrl: './demandeur.component.html',
  styleUrls: ['./demandeur.component.scss']
})
export class DemandeurComponent implements OnInit {
  @Input() dossier: Dossiers;
  @Input() rolesConnecte: rolesDar[];
  @Output() onDemandeurUpdated = new EventEmitter<Dossiers>();
  rolesDarEnum = rolesDar;
  constructor(private dialog: MatDialog,
              private snackSvc: SnackBarToastyService,
              public dossierSvc: DarDossiersService,
              private individuService: IndividuService) { }

  ngOnInit(): void {
  }
  hasRole(role: rolesDar): Observable<boolean> {
    return RoleHelper.hasRoleConnecteAsync(role, this.rolesConnecte);
  }
  /**
   * Changement demandeur
   */
  demandeurFullName() {
    return `${this.dossier?.individu?.first_name}  ${this.dossier?.individu?.last_name}`;
  }

  onSelectNewDemandeur(ldapUser: LdapUser) {
    const uid = ldapUser.uid[0];
    const currentDemandeur = this.demandeurFullName();
    const data = new DialogData();
    data.title = 'Remplacement du demandeur.';
    data.message = `Vous êtes sur le point de remplacer le demandeur d'origine <strong>${currentDemandeur}</strong> par <strong>${ldapUser.displayName[0]}</strong>.
                <br/>Confirmez-vous le remplacement ?`;

    const dialogRef = this.dialog.open(DialogValidationComponent, {
      data: data,
      position: {top: '50px'}
    });

    dialogRef.afterClosed().pipe(
      filter(result => !!result),
      concatMap(() => this.individuService.getOrCreate(uid)), // fix TG-376
      switchMap(() => this.dossierSvc.changeDemandeur(this.dossier.uuid, uid)
        .pipe(finalize(() => {
            this.snackSvc.toasty('Demandeur', 'le demandeur a bien été modifié', typeToast.success);
            this.onDemandeurUpdated.emit(this.dossier);
          })
        )),
    ).subscribe();
  }
  getTitleDemandeur(type: 'title' | 'description'): string {
    const wordings: Map<string, string> = new Map<string, string>([
      ['title', 'Remplacement du demandeur d\'origine, cliquer pour affecter cette dar à un nouveau demandeur.'],
      ['description',  'Rechercher dans l\'annuaire LDAP et sélectionner une personne pour l\'associer à cette DAR.']
    ]);
    return wordings.get(type) || '';
  }
}
